import { useState } from 'react';

import responsiveValue from 'js/utils/responsive-value';
import useResize from 'js/hooks/use-resize';

import Carousel from 'components/carousel/Carousel';
import Button from 'components/button/Button';
import HeightOfChild from 'components/height-of-child/HeightOfChild';

import ProcessItem from './ProcessItem';

import { IProcessCarousel } from 'source/NFR.types';

// Keeping breakpoints outside of component should be fine
// because this state applies to all ProcessCarousels on a page.
const breakpoints = {
  '0px': 1,
  '510px': 2,
  '768px': 3
};
const DEFAULT_ITEMS = 3;

const ProcessCarousel: React.FC<IProcessCarousel> = ({ items, labels }) => {
  const [numberOfSlidesToShow, setNumberOfSlidesToShow] = useState(DEFAULT_ITEMS);

  const updateNumberOfSlides = () => {
    const slidesToShow = Math.min(items.length, responsiveValue<number | undefined>(breakpoints) ?? DEFAULT_ITEMS);
    setNumberOfSlidesToShow(slidesToShow);
  };

  useResize(updateNumberOfSlides);

  return (
    <HeightOfChild className="process-carousel">
      {Child => (
        <Carousel
          numberOfSlidesToShow={numberOfSlidesToShow}
          nextLabel={labels.next}
          previousLabel={labels.previous}
          nextButton={(next, hasNext) => (
            <Button
              className="process-carousel__button process-carousel__button-next"
              disabled={!hasNext}
              icon="arrow-rounded"
              onClick={next}
              title={labels.next}
            />
          )}
          previousButton={(prev, hasPrev) => (
            <Button
              className="process-carousel__button process-carousel__button-prev"
              disabled={!hasPrev}
              icon="arrow-rounded"
              onClick={prev}
              title={labels.previous}
            />
          )}
        >
          {items?.map((item, index) => (
            <Child className="process-carousel--item" key={item.title || item.text || index}>
              <ProcessItem key={item.text} {...item} index={index} />
            </Child>
          ))}
        </Carousel>
      )}
    </HeightOfChild>
  );
};

ProcessCarousel.displayName = 'ProcessCarousel';

export default ProcessCarousel;
